import { auth } from './init';

/*
 * User roles are Firebase Auth custom claims. A user with no `role` claim is a plain student; only
 * instructors and admins carry the claim. The claim is set server-side (functions setUserRole /
 * scripts/set-role.js) and read here from the ID token. Because claims ride in the token, a freshly
 * promoted user only sees their new role after their token refreshes (auto ~hourly, or on re-login).
 */

export type Role = 'student' | 'instructor' | 'admin';

/** Read the current user's role from their ID token. Returns 'student' when signed out or unclaimed. */
export async function getCurrentRole(): Promise<Role> {
  const user = auth.currentUser;
  if (!user) return 'student';
  const result = await user.getIdTokenResult();
  const { role } = result.claims;
  return role === 'instructor' || role === 'admin' ? role : 'student';
}

/** True when the role is instructor or admin (i.e. elevated "staff" access). */
export function isStaffRole(role?: string | null): boolean {
  return role === 'instructor' || role === 'admin';
}
